import { cn } from "@/lib/utils";
import { business } from "@/config/business";
import { localizePath, useI18n } from "@/i18n";
import { accessibilityCopy } from "@/i18n/accessibility";

export function Wordmark({ onDark = false, className }: { onDark?: boolean; className?: string }) {
  const { locale } = useI18n();

  return (
    <a
      href={localizePath("/", locale)}
      className={cn("group inline-flex min-w-0 items-center gap-2.5", className)}
      aria-label={`${business.name}: ${accessibilityCopy[locale].home}`}
    >
      <img
        src="/RevolinGroup-new-logo.png"
        alt=""
        width={687}
        height={687}
        className="size-12 shrink-0 object-contain sm:size-14"
        decoding="async"
      />
      <span className="flex min-w-0 flex-col leading-none">
        <span
          lang="en"
          className={cn(
            "font-display whitespace-nowrap text-base font-bold tracking-[0.08em] uppercase sm:text-lg",
            onDark ? "text-primary-foreground" : "text-foreground",
          )}
        >
          Revolin <span className={onDark ? "text-gold" : "text-accent"}>Roofing</span>
        </span>
        <span
          lang={locale === "fa-ir" ? "fa" : locale === "ar-sa" ? "ar" : "en"}
          className={cn(
            "mt-1.5 whitespace-nowrap text-[0.58rem] font-semibold tracking-[0.14em] uppercase sm:text-[0.62rem]",
            onDark ? "text-primary-foreground/65" : "text-muted-foreground",
          )}
        >
          {locale === "fa-ir"
            ? "از شرکت‌های گروه رولین"
            : locale === "ar-sa"
              ? "إحدى شركات مجموعة رولين"
              : business.parent}
        </span>
      </span>
    </a>
  );
}
